import { render, staticRenderFns } from "./NewUserTemplateModal.vue?vue&type=template&id=7630c052&lang=pug&"
import script from "./NewUserTemplateModal.vue?vue&type=script&lang=js&"
export * from "./NewUserTemplateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports